module.exports = __webpack_public_path__ + "img/illustration.cddfe742.png";